import { createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/gdp/gdp_tip.png'
import _imports_1 from '../../assets/img/gdp/gdp_75.png'
import _imports_2 from '../../assets/img/gdp/back_btn.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-39bfc5a5")

_pushScopeId("data-v-39bfc5a5")
const _hoisted_1 = { class: "gdp" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div style=\"min-height:80vw;\" data-v-39bfc5a5><div class=\"gdp-title\" style=\"opacity:0;animation:backInDown 1.2s 0s ease forwards;\" data-v-39bfc5a5>奋进强国路<br data-v-39bfc5a5>阔步新征程</div><div class=\"gdp-desc\" data-v-39bfc5a5><p style=\"opacity:0;animation:fadeInUp 1.2s 0.3s ease forwards;\" data-v-39bfc5a5>75年来</p><p style=\"opacity:0;animation:fadeInUp 1.2s 0.6s ease forwards;\" data-v-39bfc5a5>在中国共产党的坚强领导下</p><p style=\"opacity:0;animation:fadeInUp 1.2s 0.9s ease forwards;\" data-v-39bfc5a5>中国从温饱不足迈向全面小康</p><p style=\"opacity:0;animation:fadeInUp 1.2s 1.2s ease forwards;\" data-v-39bfc5a5>从积贫积弱迈向繁荣富强</p><p style=\"opacity:0;animation:fadeInUp 1.2s 1.5s ease forwards;\" data-v-39bfc5a5>创造了人类发展史上的伟大奇迹</p><br data-v-39bfc5a5><br data-v-39bfc5a5><p style=\"opacity:0;animation:fadeInUp 1.2s 1.8s ease forwards;\" data-v-39bfc5a5>党的十八大以来</p><p style=\"opacity:0;animation:fadeInUp 1.2s 2.1s ease forwards;\" data-v-39bfc5a5>以习近平同志为核心的党中央</p><p style=\"opacity:0;animation:fadeInUp 1.2s 2.4s ease forwards;\" data-v-39bfc5a5>高瞻远瞩、统揽全局、把握大势</p><p style=\"opacity:0;animation:fadeInUp 1.2s 2.7s ease forwards;\" data-v-39bfc5a5>推动中国经济巨轮</p><p style=\"opacity:0;animation:fadeInUp 1.2s 3.0s ease forwards;\" data-v-39bfc5a5>乘风破浪、行稳致远</p></div></div>", 1)
const _hoisted_3 = { class: "gdb-content" }
const _hoisted_4 = {
  id: "gdp-chart",
  class: "chart"
}
const _hoisted_5 = { class: "gdp-text" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0s ease forwards"} }, "新中国成立初期，我国经济基础极为薄弱。", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0.3s ease forwards"} }, "1952年，我国国内生产总值仅为679亿元。", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0.6s ease forwards"} }, "到了1978年，国内生产总值为3645亿元，", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0.9s ease forwards"} }, "仅占全球的1.8%。", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0s ease forwards"} }, "经过长期努力，尤其是改革开放之后，", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0.3s ease forwards"} }, "我国经济总量连上新台阶。", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0.6s ease forwards"} }, "1992年，我国国内生产总值达2.39万亿元人民币，", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0.9s ease forwards"} }, "正式进入全球前十。", -1)
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0s ease forwards"} }, "2003年以来，", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0.3s ease forwards"} }, "我国经济连续五年保持两位数以上的增长速度。", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0.6s ease forwards"} }, "2010年，我国国内生产总值超越日本，", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0..9s ease forwards"} }, "正式成为全球第二大经济体。", -1)
const _hoisted_22 = { key: 3 }
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<p style=\"opacity:0;animation:fadeInUp 1.5s 0s ease forwards;\" data-v-39bfc5a5>多年来</p><p style=\"opacity:0;animation:fadeInUp 1.5s 0.3s ease forwards;\" data-v-39bfc5a5>中国对世界经济增长的贡献率保持在</p><p style=\"opacity:0;animation:fadeInUp 1.5s 0.6s ease forwards;\" data-v-39bfc5a5><span style=\"font-size:12vw;font-family:&#39;jdzh&#39;;line-height:1em;padding-top:1vw;\" id=\"gxgdp\" data-v-39bfc5a5>0%</span>左右</p><p style=\"opacity:0;animation:fadeInUp 1.5s 0.9s ease forwards;\" data-v-39bfc5a5>是世界经济增长的<span data-v-39bfc5a5>最大引擎</span></p><p style=\"opacity:0;animation:fadeInUp 1.5s 1.2s ease forwards;\" data-v-39bfc5a5>中国用几十年的时间</p><p style=\"opacity:0;animation:fadeInUp 1.5s 1.5s ease forwards;\" data-v-39bfc5a5>走过了发达国家几百年走过的发展</p>", 6)
const _hoisted_29 = {
  key: 1,
  src: _imports_0,
  alt: "",
  style: {"margin-top":"5vw","opacity":"0","animation":"fadeInUp 2s 0s ease forwards"}
}
const _hoisted_30 = {
  key: 2,
  style: {"font-size":"11vw","line-height":"1.1em","color":"black","font-family":"'jdzh'","margin-top":"3vw","opacity":"0","animation":"fadeInUp 2s 0s ease forwards"},
  id: "gdp-year"
}
const _hoisted_31 = { class: "gdp-country-flag" }
const _hoisted_32 = { class: "gdp-end" }
const _hoisted_33 = {
  src: _imports_1,
  id: "gdp-end-1",
  alt: "",
  style: {"animation":"zoomIn 0.6s 0s ease forwards"}
}
const _hoisted_34 = { id: "gdp-end-2" }
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<p style=\"font-size:11vw;color:#c02c38;line-height:1.2em;opacity:0;animation:fadeInUp 1.5s 0s ease forwards;\" data-v-39bfc5a5>75年披荆斩棘</p><p style=\"font-size:11vw;color:#c02c38;line-height:1.2em;margin-bottom:2vw;opacity:0;animation:fadeInUp 1.5s 0.3s ease forwards;\" data-v-39bfc5a5>75年沧桑巨变</p><p style=\"opacity:0;animation:fadeInUp 1.5s 0.6s ease forwards;\" data-v-39bfc5a5>回望过去</p><p style=\"opacity:0;animation:fadeInUp 1.5s 0.9s ease forwards;\" data-v-39bfc5a5>中国经济创造奇迹、实现跃升</p><br data-v-39bfc5a5><p style=\"opacity:0;animation:fadeInUp 1.5s 1.2s ease forwards;\" data-v-39bfc5a5>展望未来</p><p style=\"opacity:0;animation:fadeInUp 1.5s 1.5s ease forwards;\" data-v-39bfc5a5>在以习近平同志为核心的党中央坚强领导下</p><p style=\"opacity:0;animation:fadeInUp 1.5s 1.8s ease forwards;\" data-v-39bfc5a5>中国经济高质量发展步履坚定</p><p style=\"opacity:0;animation:fadeInUp 1.5s 2.1s ease forwards;\" data-v-39bfc5a5>必将开拓出更加光明的发展前景</p><div style=\"text-align:center;\" data-v-39bfc5a5><p class=\"statistics-text\" style=\"opacity:0;animation:fadeInUp 1.5s 2.4s ease forwards;\" data-v-39bfc5a5>数据来源于国家统计局等官方网站</p></div>", 10)
const _hoisted_45 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _withDirectives(_createVNode("div", _hoisted_4, null, 512), [
        [_vShow, _ctx.isShowGdpChart]
      ]),
      _createVNode("div", _hoisted_5, [
        (_ctx.isShowGdpIntro)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              (_ctx.gdpIntroStep === 0)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11
                  ]))
                : _createCommentVNode("", true),
              (_ctx.gdpIntroStep === 1)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16
                  ]))
                : _createCommentVNode("", true),
              (_ctx.gdpIntroStep === 2)
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _hoisted_18,
                    _hoisted_19,
                    _hoisted_20,
                    _hoisted_21
                  ]))
                : _createCommentVNode("", true),
              (_ctx.gdpIntroStep === 3)
                ? (_openBlock(), _createBlock("div", _hoisted_22, [
                    _hoisted_23
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isShowGdpChart)
          ? (_openBlock(), _createBlock("img", _hoisted_29))
          : _createCommentVNode("", true),
        (_ctx.isShowGdpChart)
          ? (_openBlock(), _createBlock("p", _hoisted_30, "1992"))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_31, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.flags, (item) => {
        return (_openBlock(), _createBlock("img", {
          src: `https://yunyingcdn.thecover.cn/china-data/flags/${ item }.png`,
          key: item,
          alt: ""
        }, null, 8, ["src"]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.isShowGdpChart]
    ]),
    _createVNode("div", _hoisted_32, [
      _withDirectives(_createVNode("img", _hoisted_33, null, 512), [
        [_vShow, _ctx.gdpEndStep >= 1]
      ]),
      _withDirectives(_createVNode("div", _hoisted_34, [
        _hoisted_35,
        _createVNode("div", {
          style: {"opacity":"0","animation":"fadeInUp 1.5s 2.7s ease forwards"},
          class: "btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
        }, [
          _hoisted_45
        ])
      ], 512), [
        [_vShow, _ctx.gdpEndStep >= 2]
      ])
    ])
  ]))
})